"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JournalAdapter {
    constructor(api) {
        this.api = api;
    }
    getLifeJournalEntry(customerId, date) {
        return this.api.getLifeJournalDailyEntries(customerId, date);
    }
    getMindJournalEntry(customerId, date) {
        return this.api.getMindJournalDailyEntries(customerId, date);
    }
    getLifeWeeklyEntries(customerId, startDate, endDate) {
        return this.api.getLifeWeeklyEntries(customerId, startDate, endDate);
    }
    getMindWeeklyEntries(customerId, startDate, endDate) {
        return this.api.getMindWeeklyEntries(customerId, startDate, endDate);
    }
}
exports.default = JournalAdapter;
//# sourceMappingURL=JournalAdapter.js.map